<div class="footer bg-danger">
    <div class="row no-gutters p-2">
        <div class="col-lg-12 text-center">
            <h3 style="font-size: 20px; color: white;"> Chat Monella 2020 - Servizio offerto da Easyline SRLS | P.I.
                02673720021 </h3>
        </div>
    </div>
</div>